<!--  -->
<template>
  <div class="container">
    <Header></Header>
    <div class="zxcpbanner"></div>
    <div class="bigBox">
      <div class="w1200">
        <div class="zxcp_title">
          <h2>咨询产品</h2>
        </div>
        <el-container>
          <el-aside width="260px">
            <el-menu
              :default-active="activeMenu"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
              background-color="#545c64"
              text-color="#fff"
              active-text-color="#ffd04b"
              :router="true"
              :unique-opened="true"
            >
              <el-submenu
                :index="menuListData.path"
                v-for="menuListData in menuListDatas"
                :key="menuListData.id"
              >
                <template slot="title">
                  <span>{{ menuListData.title }}</span>
                </template>
                <el-menu-item
                  :index="menuList.path"
                  :class="activeMenu == menuList.path ? 'active' : ''"
                  v-for="menuList in menuListData.child"
                  :key="menuList.id"
                  >{{ menuList.title }}</el-menu-item
                >
              </el-submenu>
            </el-menu></el-aside
          >
          <el-main><router-view></router-view></el-main>
        </el-container>
      </div>
    </div>
    <Footer></Footer>
    <scollTop></scollTop>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import scollTop from "@/components/scollTop.vue";
export default {
  components: {
    Header,
    Footer,
    scollTop,
  },
  name: "ComponentName",
  data() {
    //这里存放数据
    return {
      menuListDatas: [
        {
          id: 1,
          title: "战略咨询",
          path: "strategy",
          child: [
            {
              id: 1001,
              title: "战略规划",
              path: "strategy",
            },
          ],
        },
        {
          id: 2,
          title: "品牌咨询",
          path: "brand",
          child: [
            {
              id: 2001,
              title: "品牌改革",
              path: "brand",
            },
          ],
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      console.log(meta, path);
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
<style lang='less' scoped>
.container {
  width: 100%;
  .zxcpbanner {
    background: url("https://www.best-consulting.com/skins/default/images/zxcpbanner.jpg")
      center no-repeat;
    margin-top: 5px;
    height: 310px;
  }
  .zxcp_title {
    border-bottom: 1px #dcdcdc solid;
    overflow: hidden;
    height: 97px;
    h2 {
      height: 97px;
      padding-top: 28px;
      float: left;
      line-height: 69px;
      font-size: 22px;
      color: #1a408b;
      text-indent: 33px;
    }
  }
  .el-aside {
    .el-menu {
      border-right: none;
      font-size: 18px !important;
      .el-menu-item {
        height: 66px;
        font-size: 18px;
        font-weight: bold;
        line-height: 66px;
        //高亮显示
        &.active {
          color: #ffffff !important;
          background-color: #0082c8 !important;
          height: 69px !important;
        }
      }
    }
  }
  /deep/.el-submenu .el-submenu__title {
    height: 66px;
    font-size: 18px;
    line-height: 66px;
  }
}
</style>